import { render, staticRenderFns } from "./BrowseElevator.vue?vue&type=template&id=53027bc6&scoped=true&"
import script from "./BrowseElevator.vue?vue&type=script&lang=js&"
export * from "./BrowseElevator.vue?vue&type=script&lang=js&"
import style0 from "./BrowseElevator.vue?vue&type=style&index=0&id=53027bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53027bc6",
  null
  
)

export default component.exports